"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bagItemsPerPage = exports.spellbookAbilitiesPerPage = exports.questLogInProgressQuestsPerPage = exports.questLogCompletedQuestsPerPage = exports.npcQuestsPerPage = exports.markerDuration = exports.mainMenuCharactersPerPage = exports.emotesPerPage = exports.chestOpenDuration = exports.bankToggleDuration = void 0;
exports.bankToggleDuration = 267 / 2;
exports.chestOpenDuration = 267 / 2;
exports.emotesPerPage = 25;
exports.mainMenuCharactersPerPage = 7;
exports.markerDuration = 267 * 2;
exports.npcQuestsPerPage = 3;
exports.questLogCompletedQuestsPerPage = 7;
exports.questLogInProgressQuestsPerPage = 7;
exports.spellbookAbilitiesPerPage = 7;
exports.bagItemsPerPage = 8;
